import { Checkbox } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface CustomToggleProps {
    disabled?: boolean;
    onChange?: (checked: boolean) => void;
    checked: boolean;
    title?: string;
    className?: string;
    style?: React.CSSProperties;
}

const CustomToggle: React.FC<CustomToggleProps> = ({ disabled = false, onChange = () => {}, checked, title, className = '', style }) => {
    const { t } = useTranslation();
    return (
        <Checkbox
            checked={checked}
            value={checked ? t('yes') : t('no')}
            onChange={(event) => onChange(event.target.checked)}
            disabled={disabled}
            title={title}
            color="secondary"
        />
    );
};

export default CustomToggle;
